import { render, staticRenderFns } from "./CreditNoteComponent.vue?vue&type=template&id=e1962004&scoped=true"
import script from "./CreditNoteComponent.vue?vue&type=script&lang=js"
export * from "./CreditNoteComponent.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteComponent.vue?vue&type=style&index=0&id=e1962004&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1962004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1962004')) {
      api.createRecord('e1962004', component.options)
    } else {
      api.reload('e1962004', component.options)
    }
    module.hot.accept("./CreditNoteComponent.vue?vue&type=template&id=e1962004&scoped=true", function () {
      api.rerender('e1962004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/creditnote/CreditNoteComponent.vue"
export default component.exports